import { lazy } from 'react';
import { lazyRetry } from './lazyRetry';

// Lazy load all page components (with retry for chunk failures)
export const Auth = lazy(() => lazyRetry(() => import('../pages/Auth')));
export const TrustCenter = lazy(() => lazyRetry(() => import('../pages/TrustCenter')));
export const ExercerMesDroits = lazy(() => lazyRetry(() => import('../pages/ExercerMesDroits')));
export const AuditAccess = lazy(() => lazyRetry(() => import('../pages/AuditAccess')));
export const ResetPassword = lazy(() => import('../pages/ResetPassword'));
export const ForceChangePassword = lazy(() => import('../pages/ForceChangePassword'));
export const Dashboard = lazy(() => import('../pages/Dashboard'));
export const UserHub = lazy(() => import('../pages/UserHub'));
export const Fournisseurs = lazy(() => import('../pages/Fournisseurs'));
export const Caisse = lazy(() => import('../pages/Caisse'));
export const BonsEnCours = lazy(() => import('../pages/BonsEnCours'));
export const CaisseRapide = lazy(() => import('../pages/caisse-rapide/CaisseRapide'));
export const CaisseRestaurant = lazy(() => lazyRetry(() => import('../pages/CaisseRestaurant')));
export const Demo = lazy(() => import('../pages/Demo'));
export const Produits = lazy(() => import('../pages/Produits'));
export const Integrer = lazy(() => import('../pages/Integrer'));
export const Ventes = lazy(() => import('../pages/Ventes'));
export const Rapports = lazy(() => import('../pages/Rapports'));
export const Clients = lazy(() => import('../pages/Clients'));
export const Etiquettes = lazy(() => import('../pages/Etiquettes'));
export const Avoirs = lazy(() => import('../pages/Avoirs'));
export const Duplicata = lazy(() => import('../pages/Duplicata'));
export const NoteDeFrais = lazy(() => import('../pages/NoteDeFrais'));
export const Encours = lazy(() => import('../pages/Encours'));
export const BonsDeLivraison = lazy(() => import('../pages/BonsDeLivraison'));
export const Devis = lazy(() => import('../pages/Devis'));
export const FacturationBl = lazy(() => import('../pages/FacturationBl'));
export const FacturesClients = lazy(() => import('../pages/FacturesClients'));
export const SessionsCaisse = lazy(() => import('../pages/SessionsCaisse'));
export const PiecesCommerciales = lazy(() => import('../pages/PiecesCommerciales'));
export const LignesVente = lazy(() => import('../pages/LignesVente'));
export const EtatStocks = lazy(() => import('../pages/etat-stocks/EtatStocksRoute'));
export const MouvementsStock = lazy(() => import('../pages/MouvementsStock'));
export const Inventaires = lazy(() => import('../pages/Inventaires'));
export const ModeStock = lazy(() => import('../pages/ModeStock'));
export const TypesFidelite = lazy(() => import('../pages/TypesFidelite'));
export const BonsReduction = lazy(() => import('../pages/BonsReduction'));
export const MouvementsFidelite = lazy(() => import('../pages/MouvementsFidelite'));
export const CartesCadeaux = lazy(() => import('../pages/CartesCadeaux'));
export const SmsMarketing = lazy(() => import('../pages/SmsMarketing'));
export const MagicSms = lazy(() => import('../pages/MagicSms'));
export const RewardsStore = lazy(() => import('../pages/config/RewardsStore'));
export const ReferralProgram = lazy(() => import('../pages/config/ReferralProgram'));
export const GoogleReviews = lazy(() => import('../pages/config/GoogleReviews'));
export const Promotions = lazy(() => import('../pages/Promotions'));
export const OperationsCommerciales = lazy(() => import('../pages/OperationsCommerciales'));
export const PersonnalisationDocs = lazy(() => import('../pages/PersonnalisationDocs'));
export const Coffre = lazy(() => import('../pages/Coffre'));
export const Comptabilite = lazy(() => import('../pages/Comptabilite'));
export const TransfertComptable = lazy(() => import('../pages/TransfertComptable'));
export const Utilisateurs = lazy(() => import('../pages/Utilisateurs'));
export const ProfilsAcces = lazy(() => import('../pages/ProfilsAcces'));
export const CommandesWeb = lazy(() => import('../pages/CommandesWeb'));
export const ParametresWeb = lazy(() => import('../pages/ParametresWeb'));
export const NotFound = lazy(() => import('../pages/NotFound'));
export const Tutoriels = lazy(() => import('../pages/Tutoriels'));
export const Landing = lazy(() => import('../pages/Landing'));
export const CloturesZ = lazy(() => import('../pages/CloturesZ'));
export const JournalFiscal = lazy(() => import('../pages/JournalFiscal'));
export const MonCompte = lazy(() => import('../pages/MonCompte'));
export const AdminPortal = lazy(() => import('../pages/AdminPortal'));
export const ZRecompute = lazy(() => import('../pages/admin/ZRecompute'));
export const AdminDashboardV2 = lazy(() => import('../pages/AdminDashboardV2'));
export const ResellerDetailPage = lazy(() => import('../pages/ResellerDetailPage'));
export const ResellerPortal = lazy(() => import('../pages/ResellerPortal'));
export const TenantApp = lazy(() => import('../pages/TenantApp'));
export const TransactionsCB = lazy(() => import('../pages/TransactionsCB'));
export const TransactionsCBExternes = lazy(() => import('../pages/TransactionsCBExternes'));
export const MyPOSClientConfig = lazy(() => import('../pages/MyPOSClientConfig'));
export const MyPOSStaffConfig = lazy(() => import('../pages/MyPOSStaffConfig'));
export const NF525Dashboard = lazy(() => import('../pages/NF525Dashboard'));
export const RapportFiscal = lazy(() => import('../pages/RapportFiscal'));
export const Unsubscribe = lazy(() => import('../pages/Unsubscribe'));
export const PrintersConfig = lazy(() => import('../pages/PrintersConfig'));
export const MonnayeurConfig = lazy(() => import('../pages/MonnayeurConfig'));
export const BalanceConfig = lazy(() => import('../pages/BalanceConfig'));
export const StaffBadges = lazy(() => import('../pages/StaffBadges'));
export const QuickLogin = lazy(() => import('../pages/QuickLogin'));
export const CatalogueIntegration = lazy(() => import('../pages/CatalogueIntegration'));

// Kitchen Display System (KDS) + Salle Display
export const KitchenDisplay = lazy(() => lazyRetry(() => import('../pages/KitchenDisplay')));
export const SalleDisplay = lazy(() => lazyRetry(() => import('../pages/SalleDisplay')));

// Togo module
export const TogoImprimantes = lazy(() => import('../pages/togo/TogoImprimantes'));
export const TogoTickets = lazy(() => import('../pages/togo/TogoTickets'));
export const TogoTPE = lazy(() => import('../pages/togo/TogoTPE'));
export const TogoMateriel = lazy(() => import('../pages/togo/TogoMateriel'));

// CHR module (Café-Hôtel-Restaurant)
export const FloorPlan = lazy(() => import('../pages/chr/FloorPlan'));
export const TableSession = lazy(() => import('../pages/chr/TableSession'));
export const HotelRooms = lazy(() => import('../pages/chr/HotelRooms'));
export const CheckIn = lazy(() => import('../pages/chr/CheckIn'));
export const GuestRegister = lazy(() => import('../pages/chr/GuestRegister'));
export const ArdoisesBar = lazy(() => import('../pages/chr/ardoises/ArdoisesBar'));
export const WaiterPad = lazy(() => lazyRetry(() => import('../pages/chr/WaiterPad')));
export const Kiosque = lazy(() => lazyRetry(() => import('../pages/Kiosque')));
export const OrderTracker = lazy(() => lazyRetry(() => import('../pages/OrderTracker')));

// Config pages
export const ModuleManagement = lazy(() => import('../pages/config/ModuleManagement'));
export const EcranClient = lazy(() => import('../pages/config/EcranClient'));
export const Display = lazy(() => import('../pages/display/Display'));
export const Familles = lazy(() => import('../pages/config/Familles'));
export const SousFamilles = lazy(() => import('../pages/config/SousFamilles'));
export const Marques = lazy(() => import('../pages/config/Marques'));
export const Classifications = lazy(() => import('../pages/config/Classifications'));
export const Caracteristiques = lazy(() => import('../pages/config/Caracteristiques'));
export const Variantes = lazy(() => import('../pages/config/Variantes'));
export const FamillesClients = lazy(() => import('../pages/config/FamillesClients'));
export const FamillesFournisseurs = lazy(() => import('../pages/config/FamillesFournisseurs'));
export const FamillesTarifaires = lazy(() => import('../pages/config/FamillesTarifaires'));
export const Provenances = lazy(() => import('../pages/config/Provenances'));
export const Commentaires = lazy(() => import('../pages/config/Commentaires'));
export const Libelles = lazy(() => import('../pages/config/Libelles'));
export const TypesMouvement = lazy(() => import('../pages/config/TypesMouvement'));
export const ModesReglement = lazy(() => import('../pages/config/ModesReglement'));
export const DelaisPaiement = lazy(() => import('../pages/config/DelaisPaiement'));
export const FondsCaisse = lazy(() => import('../pages/config/FondsCaisse'));
export const ProfilsComptables = lazy(() => import('../pages/config/ProfilsComptables'));
export const ProfilsTVA = lazy(() => import('../pages/config/ProfilsTVA'));
export const Taxes = lazy(() => import('../pages/config/Taxes'));
export const ComptesBancaires = lazy(() => import('../pages/config/ComptesBancaires'));
export const Devises = lazy(() => import('../pages/config/Devises'));
export const PistesAudit = lazy(() => import('../pages/config/PistesAudit'));
export const ArchivesFiscales = lazy(() => import('../pages/config/ArchivesFiscales'));
export const ClotureComptable = lazy(() => import('../pages/ClotureComptable'));
export const Lekompte = lazy(() => import('../pages/config/Lekompte'));
export const PeriodesJour = lazy(() =>
  import('../pages/config/Periodes').then((m) => ({ default: m.PeriodesJour })),
);
export const PeriodesMois = lazy(() =>
  import('../pages/config/Periodes').then((m) => ({ default: m.PeriodesMois })),
);
export const PeriodesAnnee = lazy(() =>
  import('../pages/config/Periodes').then((m) => ({ default: m.PeriodesAnnee })),
);
export const PeriodesComptable = lazy(() =>
  import('../pages/config/Periodes').then((m) => ({ default: m.PeriodesComptable })),
);
export const Certificat = lazy(() => import('../pages/config/Certificat'));
export const HardwareConfig = lazy(() => import('../pages/config/HardwareConfig'));
export const ProfilsFidelite = lazy(() => import('../pages/config/ProfilsFidelite'));
export const FidelitePunch = lazy(() => import('../pages/config/FidelitePunch'));
export const ReviewRedirect = lazy(() => import('../pages/ReviewRedirect'));
export const TenantsMonitoring = lazy(() => import('../pages/admin/TenantsMonitoring'));
export const TpeMonitoring = lazy(() => import('../pages/admin/TpeMonitoring'));
export const InstallationTools = lazy(() => import('../pages/admin/InstallationTools'));
export const CashRecyclerFleet = lazy(() => import('../pages/admin/CashRecyclerFleet'));
export const DashboardKPI = lazy(() => import('../pages/DashboardKPI'));
export const Identites = lazy(() => import('../pages/config/Identites'));
export const CodesPostaux = lazy(() => import('../pages/config/CodesPostaux'));
export const Pays = lazy(() => import('../pages/config/Pays'));
export const ZonesLivraison = lazy(() => import('../pages/config/ZonesLivraison'));
export const PostesTravail = lazy(() => import('../pages/config/PostesTravail'));
export const ImportDonnees = lazy(() => import('../pages/config/ImportDonnees'));
export const ParametresDossier = lazy(() => import('../pages/config/ParametresDossier'));
export const ConfigFeatureFlags = lazy(() => import('../pages/config/ConfigFeatureFlags'));
export const ConfigKioskMode = lazy(() => import('../pages/config/ConfigKioskMode'));
export const ConfigAppareils = lazy(() => import('../pages/config/ConfigAppareils'));
export const ConfigUniverses = lazy(() => import('../pages/config/ConfigUniverses'));
export const ConfigTPE = lazy(() => import('../pages/config/ConfigTPE'));
export const TpeBluetoothManager = lazy(() => import('../pages/config/TpeBluetoothManager'));

export const LicenseActivation = lazy(() => import('../pages/LicenseActivation'));
export const HomeScreenSelector = lazy(() => import('../components/HomeScreenSelector'));
